import { Navigate, Route, Routes } from "react-router-dom";
import { useAuth } from "./context/AuthContext";
import { ProjectProvider } from "./context/ProjectContext";
import { Landing } from "./pages/Landing";
import { Login } from "./pages/Login";
import { Register } from "./pages/Register";
import { DashboardLayout } from "./components/DashboardLayout";
import { Overview } from "./pages/dashboard/Overview";
import { Boards } from "./pages/dashboard/Boards";
import { BoardEditor } from "./pages/dashboard/BoardEditor";
import { BoardInspector } from "./pages/dashboard/BoardInspector";
import { ApiKeys } from "./pages/dashboard/ApiKeys";
import { Players } from "./pages/dashboard/Players";
import { Moderation } from "./pages/dashboard/Moderation";
import { Settings } from "./pages/dashboard/Settings";

function FullScreenLoader() {
  return (
    <div style={{ display: "grid", placeItems: "center", minHeight: "100vh" }}>
      <span className="spinner" style={{ width: 28, height: 28 }} />
    </div>
  );
}

function Protected({ children }: { children: React.ReactNode }) {
  const { user, loading } = useAuth();
  if (loading) return <FullScreenLoader />;
  if (!user) return <Navigate to="/login" replace />;
  return <ProjectProvider>{children}</ProjectProvider>;
}

function PublicOnly({ children }: { children: React.ReactNode }) {
  const { user, loading } = useAuth();
  if (loading) return <FullScreenLoader />;
  if (user) return <Navigate to="/app" replace />;
  return <>{children}</>;
}

export default function App() {
  return (
    <Routes>
      <Route path="/" element={<Landing />} />
      <Route path="/login" element={<PublicOnly><Login /></PublicOnly>} />
      <Route path="/register" element={<PublicOnly><Register /></PublicOnly>} />

      <Route path="/app" element={<Protected><DashboardLayout /></Protected>}>
        <Route index element={<Overview />} />
        <Route path="boards" element={<Boards />} />
        <Route path="boards/new" element={<BoardEditor />} />
        <Route path="boards/:boardId" element={<BoardInspector />} />
        <Route path="boards/:boardId/edit" element={<BoardEditor />} />
        <Route path="players" element={<Players />} />
        <Route path="keys" element={<ApiKeys />} />
        <Route path="moderation" element={<Moderation />} />
        <Route path="settings" element={<Settings />} />
      </Route>

      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  );
}
